import { SITE_EMAIL } from "../../shared/seo/site";

export function About() {
  return (
    <main className="prose-page" id="main-content">
      <p className="eyebrow">Who makes this</p>
      <h1>About Nonogram Now</h1>
      <p className="lede">A small, deliberately quiet nonogram site: one checked puzzle a day, no account, and nothing asking for your attention while you think.</p>
      <section>
        <span className="section-number">01</span>
        <div>
          <h2>What this site is</h2>
          <p>Nonogram Now publishes one picture logic puzzle every UTC day, plus a library you can play at 5×5, 10×10, and 15×15 whenever you like. Everyone opening the site on the same date gets the same daily grid, which is what makes a time or a streak worth comparing.</p>
          <p>It exists because most puzzle sites treat the puzzle as the thing wrapped around everything else. Here the grid is the page.</p>
        </div>
      </section>
      <section>
        <span className="section-number">02</span>
        <div>
          <h2>How the puzzles are made</h2>
          <p>Every picture is drawn by hand — 264 of them so far, across animals, food, music, nature, objects, symbols, and weather. A generator turns each drawing into a grid and derives its row and column clues.</p>
          <p>Nothing ships unverified. The build re-derives the clues from the solution and runs a solver that counts solutions; a puzzle with zero solutions or more than one fails the build and never reaches the site. That check is why careful deduction is always enough, and why you never need to guess.</p>
        </div>
      </section>
      <section>
        <span className="section-number">03</span>
        <div>
          <h2>Who builds it</h2>
          <p>Nonogram Now is built and maintained by hellosun, working alone. It is a side project, not a company, and there is no team behind the "we" in the policy pages.</p>
        </div>
      </section>
      <section>
        <span className="section-number">04</span>
        <div>
          <h2>What it does not do</h2>
          <p>There are no accounts, no email list, and nothing to buy. Your unfinished grid, streak, and best times live in your own browser and are never uploaded, so clearing site data clears them and a second device starts fresh.</p>
          <p>The site records limited analytics to understand which pages people find useful. What that covers, and what it deliberately does not, is written out on the privacy page.</p>
          <p>Questions, bug reports, and suggestions go to <a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a>.</p>
        </div>
      </section>
    </main>
  );
}
